export enum StorageKey {
  ACCESS_TOKEN = 'access_token',
  CURRENT_CART = 'current_cart',
}

export const saveItemStorage = (key: StorageKey, value: unknown, isSessionStorage: boolean = false): void => {
  if (import.meta.server) return;

  const storage = isSessionStorage ? sessionStorage : localStorage;

  const storedValue = typeof value === 'string' ? value : JSON.stringify(value);

  storage.setItem(key, storedValue);
};

export const getItemStorage = <T = unknown>(key: StorageKey, isSessionStorage: boolean = false): T | null => {
  if (import.meta.server) return null;

  const storage = isSessionStorage ? sessionStorage : localStorage;
  const value = storage.getItem(key);

  if (value === null) return null;

  try {
    return JSON.parse(value) as T;
  } catch {
    return value as T;
  }
};

export const removeItemStorage = (key: StorageKey, isSessionStorage: boolean = false): void => {
  if (import.meta.server) return;

  const storage = isSessionStorage ? sessionStorage : localStorage;
  storage.removeItem(key);
};
